// Labels for application status tracking by email.
import { MailClassification } from '../types';

export const CLASSIFICATION_LABELS: Record<MailClassification, string> = {
  received: 'Application received',
  interview: 'Interview',
  assessment: 'Assessment',
  rejected: 'Rejected',
  offer: 'Offer',
  other: 'Other',
  verification: 'Verification code',
};

/** What a user may set by hand, in the order shown. */
export const USER_CLASSIFICATIONS: MailClassification[] = ['received', 'interview', 'assessment', 'offer', 'rejected', 'other'];

export const CLASSIFICATION_COLORS: Record<MailClassification, 'default' | 'primary' | 'success' | 'error' | 'warning' | 'info'> = {
  received: 'default',
  interview: 'primary',
  assessment: 'info',
  rejected: 'error',
  offer: 'success',
  other: 'default',
  verification: 'default',
};

export function senderLabel(message: { sender: string; sender_name: string }): string {
  if (message.sender_name && message.sender) return `${message.sender_name} (${message.sender})`;
  return message.sender_name || message.sender || 'Sender not recorded';
}
